import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dataFilter',
    pure: false
})

export class DataFilter implements PipeTransform {
    transform(arr: any,filter:any): any {
        if(!arr){
            return arr
        }
        return arr.filter(item => item.data.indexOf(filter) !== -1);
    }
}